//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { useDispatch } from 'react-redux';
//  -- Components ---------------------
import { Button as AntdButton, Card, Col, Collapse, Input, Row, Select } from 'antd';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';
//  -- Constants ----------------------
import { DeleteOutlined, PlusOutlined, SettingFilled } from "@ant-design/icons";
import { Assignment, Close } from '@mui/icons-material';
import {
    Autocomplete,
    Button,
    FormControl,
    IconButton,
    InputLabel,
    Modal as MTModal,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TextareaAutosize,
    TextField,
    Typography
} from '@mui/material';
import * as Sentry from '@sentry/react';
import SentryWrap from 'components/Sentry';
import Acent from 'components/Acent';
import { DeleteModal } from 'components/Dialog';
import SpinLoader from 'components/Loader/SpinLoader';
import Loading from 'components/Loading';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { filter, isEmpty } from "lodash";
import moment from 'moment-timezone';
import { useNavigate } from 'react-router-dom';
import { useDistricts } from 'store/organizations/selectors';
import { usePlacementExamDistrictList } from 'store/placement_exam/selectors';
import { handleAssignToDistrict, handleConfigureExamPlacementExamByOrg, handleConfigurePlacementExamDistrictInfo, handleDeactivateAssignToDistrict, handleListDistrictplacemetExamByExamId } from 'store/placement_exam/thunks';
import { default as COLOR, default as color } from 'utils/constants/color';
import { disableBodyScroll } from 'utils/methods/math';
import LevelManager from './LevelConfiguration';
import NativeNonNativeConfiguration, { validateNativeNonNativeLevels } from "./NativeNonNativeConfiguration";
import ProficiencyConfiguration, { validateProficiencyLevels } from "./ProficiencyConfiguration";
import LogoUploader from "./LogoUploader";
const BORDERCOLOR = [
    "rgb(200,109,152)",
    "rgb(146,158,227)",
    "rgb(80,233,200)",
    "rgb(238,206,151)",
];

const Wrapper = styled.div`
    margin: 0px auto;
    width: 100%;
    position: relative;
    top: 0px;
    min-height:90vh;
`;

const StableWrapper = styled.div`
    width: 100%;
    overflow-x: auto;
    //   @media (max-width: 992px) {
    //     padding:24px 0px;
    //   }
  `;
const CustomSelector = styled(Select)`
   width: 100%;
  .ant-select-selector {
    border: 1px solid #aea3a3 !important;
    height: 42px !important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px !important;
    }
`;

const FilterContainer = styled.span`
    font-size: 17px;
    font-weight: 500;
    cursor: pointer;
  `;
const ModalContent = styled.div`
  align-items: center;
  background-color: ${COLOR.white};
  border-radius: 3px;
  display: inline-flex;
  flex-direction: column;
  left: 50%;
  width:auto;
  height:auto;
  padding: 16px;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
`;
const ModalSection = styled.div`
  background-color: ${COLOR.white};
  display: inline-flex;
  flex-direction: column;
  width:auto;
  height:100%;
  overflow:auto;
  padding: 16px;
`;






const AssignToDsitrict = ({ openEditModal, setOpenEditModal, exam_id }) => {
    const showAlert = useAlert();
    const [orgId, setOrgId] = useState('')
    const [loader, setLoader] = useState(null)
    const [error, setError] = useState(null)
    const [code, setCode] = useState(null)
    const [searchInput, setSearchInput] = useState('')
    const [open, setOpen] = useState(false)
    const dispatch = useDispatch()

    const all_district = useDistricts()

    useEffect(() => {
        if (openEditModal) {
            setError(null)
            setCode('')
            setLoader(false)
            setSearchInput('')
            setOpen(false)
        }
    }, [openEditModal])

    const onAssignNow = async () => {
        if (!orgId) {
            showAlert(`Please select district`,"error")
            return;
        }
        setLoader(true)
        try {
            const on_assign = await dispatch(handleAssignToDistrict(orgId, exam_id))
            if (on_assign && on_assign.success) {
                if (on_assign && on_assign.data && on_assign.data.assignment_code) {
                    setCode(on_assign.data.assignment_code)
                }
                showAlert(`Assigd Successfully`,"success")

            } else if (on_assign && on_assign.status_code == '400') {
                showAlert(on_assign.message,"error")
                setError(on_assign.message)
            } else {
                showAlert(`Something went wrong`,"error")
            }
        } catch (error) {
            showAlert(`Something went wrong`,"error")
            Sentry.captureException(`381 Error during onAssignNow: ${error}`); 
        } finally {
            setLoader(false)
        }
    }
    return (
        <MTModal open={openEditModal} onClose={() => setOpenEditModal(false)}>
            <ModalContent>
                <Row style={{ justifyContent: "flex-end", width: "100%" }}>
                    <IconButton
                        onClick={e => setOpenEditModal(false)}
                        style={{ padding: 0, marginRight: 10 }}
                    >
                        <Close color="secondary" />
                    </IconButton>
                </Row>
                <h2>Assign to district</h2>

                <Row style={{ width: "100%" }}>
                    <FormControl variant="outlined" style={{ width: 400, marginTop: 12 }}>
                        <Autocomplete
                            id="orgId"
                            options={all_district || []}
                            getOptionLabel={(option) => option.displayName || ""}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            open={open}
                            onOpen={() => setOpen(true)}
                            onClose={() => setOpen(false)}
                            onInputChange={(event, newInputValue, reason) => {
                                if (reason === 'input') {
                                    setSearchInput(newInputValue || '');
                                    if (!open) setOpen(true);
                                } else if (reason === 'clear') {
                                    setSearchInput('');
                                    setOpen(false);
                                }
                            }}
                            filterOptions={(options, state) => {
                                const inputVal = state.inputValue || '';
                                if (!inputVal || !inputVal.trim()) {
                                    return [...options];
                                }
                                const searchWords = inputVal.toLowerCase().trim().split(/\s+/).filter(word => word.length > 0);
                                const filtered = options.filter((option) => {
                                    const displayName = (option.displayName || "").toLowerCase();
                                    return searchWords.every(word => displayName.includes(word));
                                });
                                return [...filtered];
                            }}
                            openOnFocus
                            disablePortal={false}
                            clearOnBlur={false}
                            selectOnFocus={false}
                            noOptionsText="No districts found"
                            autoHighlight={false}
                            ListboxProps={{
                                style: { maxHeight: '300px' },
                                key: `listbox-${searchInput}`
                            }}
                            componentsProps={{
                                popper: {
                                    style: { zIndex: 1300 },
                                    placement: 'bottom-start'
                                }
                            }}
                            value={all_district.find(district => district.id === orgId) || null}
                            onChange={(event, newValue) => {
                                setOrgId(newValue ? newValue.id : null);
                                setError('')
                                setCode('')
                                if (newValue) {
                                    setSearchInput(newValue.displayName || '');
                                }
                            }}
                            style={{ height: 40 }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Select Organization"
                                    variant="outlined"
                                />
                            )}
                        />
                    </FormControl>
                </Row>
                <ModalSection>
                    {error ? <Typography variant="subtitle2" style={{ whiteSpace: "pre-wrap" ,  marginTop:24}} color="error">
                        * {error}
                    </Typography>
                        : null}
                    {code ? <Typography variant="subtitle2" style={{ whiteSpace: "pre-wrap", marginTop:24 }} color="primary">
                        Assigned successfully with <strong style={{ color: color.greentrue }}>{code}</strong>
                    </Typography>
                        : null}
                </ModalSection>
                <Row style={{ width: "100%", marginTop: 20, justifyContent: "flex-end" }}>
                    <Button variant="contained" color="primary" disabled={loader} onClick={onAssignNow}>{loader ? <Loading size={14} white /> : null} Assign </Button>
                </Row>
            </ModalContent>
        </MTModal>
    )
}
const init_config = {
    id:'',
    title:'',
    description:'',
    logo:'',
    config:{},
    levels:{},
}
const ConfigureToDsitrict = ({ openEditModal, setOpenEditModal, district_id , config , organization , loadPlacementOrgList , exam_code , exam_data }) => {
    const showAlert = useAlert();
    const [loader, setLoader] = useState(null)
    const [error, setError] = useState(null)
    const [config_data, setConfig_data] = useState(init_config)
    const dispatch = useDispatch()
    const dispNameRef = useRef()
    const descriptionRef = useRef()
    const levels_config = useMemo(()=>{
        return config_data.levels?config_data.levels[exam_code]||[]:[];
    },[config_data,exam_code])

    const proficiency_config_levels = useMemo(() => {
        const nested = config_data.config?.proficiency_config?.[exam_code];
        if (nested !== undefined && nested !== null) {
            return Array.isArray(nested) ? nested : [];
        }
        const legacy = config_data.proficiency_config?.[exam_code];
        return Array.isArray(legacy) ? legacy : [];
    }, [config_data, exam_code]);

    const native_non_native_levels = useMemo(() => {
        const nested = config_data.config?.native_non_native_config?.[exam_code];
        if (nested !== undefined && nested !== null) {
            return Array.isArray(nested) ? nested : [];
        }
        const legacy = config_data.native_non_native_config?.[exam_code];
        return Array.isArray(legacy) ? legacy : [];
    }, [config_data, exam_code]);

    useEffect(() => {
        if(typeof config=="object" && !isEmpty(config)){
            setConfig_data(config)
        }else{
            setConfig_data(init_config)
        }
        setLoader(false)
        setError(null)
    },[ district_id , config,openEditModal])

    const total_max_point = useMemo(()=>{
        if(!exam_data?.questions) return 0;
        return exam_data?.questions?.reduce((acc, level) => Number.isNaN(acc) ? 0 : Number(acc) + Number(level.max_point), 0);
    },[exam_data])


    const onAssignNow = async () => {
        if (!district_id) {
            showAlert(`Please select district`,"error")
            return;
        }
        const levels_config_max_point = levels_config?.length > 0 ? levels_config[levels_config.length - 1].max : 0;
        if(Number(total_max_point) !== Number(levels_config_max_point)) {
            showAlert(`Level Max point is not equal to the total max point`,"error")
            return;
        }
        const proficiencyError = validateProficiencyLevels(proficiency_config_levels, total_max_point);
        if (proficiencyError) {
            showAlert(proficiencyError, "error");
            setError(proficiencyError);
            return;
        }
        const nativeNonNativeError = validateNativeNonNativeLevels(native_non_native_levels, total_max_point);
        if (nativeNonNativeError) {
            showAlert(nativeNonNativeError, "error");
            setError(nativeNonNativeError);
            return;
        }
        setLoader(true)
        try {
            const on_assign = await dispatch(handleConfigurePlacementExamDistrictInfo(district_id,config_data))
            if (on_assign && on_assign.success) {
                showAlert(`Updated Successfully`,"success")
                setOpenEditModal(false)
                setConfig_data(init_config)
                loadPlacementOrgList()
            } else if (on_assign && on_assign.status_code == '400') {
                showAlert(on_assign.message,"error")
                setError(on_assign.message)
            } else {
                showAlert(`Something went wrong`,"error")
            }
        } catch (error) {
            Sentry.captureException(`382 Error during onAssignNow: ${error}`); 
            showAlert(`Something went wrong`,"error")
        } finally {
            setLoader(false)
        }
    }
    const onDtChange = (key, value) => {
        setConfig_data((prev) => {
            if (key === "levels") {
                return {
                    ...prev,
                    levels: {
                        ...(prev.levels || {}),
                        [exam_code]: value,
                    },
                };
            }
            if (key === "proficiency_config") {
                const { proficiency_config: _legacyProf, ...rest } = prev;
                return {
                    ...rest,
                    config: {
                        ...(prev.config || {}),
                        proficiency_config: {
                            ...((prev.config && prev.config.proficiency_config) || {}),
                            [exam_code]: value,
                        },
                    },
                };
            }
            if (key === "native_non_native_config") {
                const { native_non_native_config: _legacyNn, ...rest } = prev;
                return {
                    ...rest,
                    config: {
                        ...(prev.config || {}),
                        native_non_native_config: {
                            ...((prev.config && prev.config.native_non_native_config) || {}),
                            [exam_code]: value,
                        },
                    },
                };
            }
            if (key === "criteria_enable") {
                return {
                    ...prev,
                    config: {
                        ...(prev.config || {}),
                        criteria: {
                            ...((prev.config && prev.config.criteria) || {}),
                            enable: value,
                        },
                    },
                };
            }
            return {
                ...prev,
                [key]: value,
            };
        });
    };
    return (
        <MTModal
        open={openEditModal}
        onClose={() => setOpenEditModal(false)}
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Paper
          style={{
            width: "95%",
            maxWidth: "800px",
            maxHeight: "90vh",
            overflow: "hidden",
            borderRadius: 8,
            position: "relative",
            padding: 0,
          }}
        >
          {/* Sticky Header */}
          <div
            style={{
              padding: "16px 24px",
              borderBottom: "1px solid #ddd",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#fafafa",
              position: "sticky",
              top: 0,
              zIndex: 100,
            }}
          >
            <Typography variant="h6" style={{ fontWeight: 600 }}>
              Configure {organization?.displayName || "District"}
            </Typography>
            <IconButton onClick={() => setOpenEditModal(false)}>
              <Close color="secondary" />
            </IconButton>
          </div>
      
          {/* Scrollable Content */}
          <div
            style={{
              padding: 24,
              overflowY: "auto",
              maxHeight: "calc(90vh - 64px - 64px)", // adjust for header & footer
            }}
          >
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Acent
                  inputRef={dispNameRef}
                  setValue={(v) => onDtChange("title", v)}
                  style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Title"
                  inputRef={dispNameRef}
                  value={config_data.title}
                  onChange={(e) => onDtChange("title", e.target.value)}
                />
              </Col>
      
              <Col span={24}>
                <FormControl fullWidth variant="outlined">
                  <Acent
                    inputRef={descriptionRef}
                    setValue={(v) => onDtChange("description", v)}
                    style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }}
                  />
                  <InputLabel style={{ backgroundColor: "#fff", padding: "0 4px", top: 14 }}>
                    Description
                  </InputLabel>
                  <TextareaAutosize
                    ref={descriptionRef}
                    minRows={6}
                    placeholder="Enter description"
                    style={{
                      width: "100%",
                      border: "1px solid #d9d9d9",
                      borderRadius: 4,
                      padding: 12,
                      fontFamily: "inherit",
                      overflow:"auto"
                    }}
                    value={config_data.description}
                    onChange={(e) => onDtChange("description", e.target.value)}
                  />
                </FormControl>
              </Col>
      
              <Col span={24}>
                <LogoUploader
                  src={config_data.logo}
                  style={{ height: 100 }}
                  onChange={(url) => setConfig_data({ ...config_data, logo: url })}
                />
              </Col>
      
              <Col span={24}>
                <Collapse
                  accordion
                  defaultActiveKey="levels"
                  style={{
                    width: "100%",
                    border: "1px solid #c9d3df",
                    borderRadius: 8,
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: 'column',
                    gap: 6,
                  }}
                >
                  <Collapse.Panel className='levelConfig' header="Levels configuration" key="levels">
                    <LevelManager
                      levels={levels_config}
                      onChange={(levels) => onDtChange("levels", levels)}
                      max_value={total_max_point}
                    />
                  </Collapse.Panel>
                  <Collapse.Panel className='levelConfig' header="Proficiency configuration" key="proficiency">
                    <ProficiencyConfiguration
                      levels={proficiency_config_levels}
                      onChange={(rows) => onDtChange("proficiency_config", rows)}
                      max_value={total_max_point}
                      criteriaEnable={Boolean(config_data.config?.criteria?.enable)}
                      onCriteriaEnableChange={(checked) => onDtChange("criteria_enable", checked)}
                    />
                  </Collapse.Panel>
                  <Collapse.Panel className='levelConfig' header="Native / NonNative configuration" key="native_non_native">
                    <NativeNonNativeConfiguration
                      levels={native_non_native_levels}
                      onChange={(rows) => onDtChange("native_non_native_config", rows)}
                      max_value={total_max_point}
                    />
                  </Collapse.Panel>
                </Collapse>
              </Col>
      
              {error && (
                <Col span={24}>
                  <Typography variant="subtitle2" style={{ color: "red", whiteSpace: "pre-wrap" }}>
                    * {error}
                  </Typography>
                </Col>
              )}
            </Row>
          </div>
      
          {/* Sticky Footer */}
          <div
            style={{
              padding: 16,
              borderTop: "1px solid #eee",
              background: "#fff",
              textAlign: "right",
              position: "sticky",
              bottom: 0,
              zIndex: 100,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              disabled={loader}
              onClick={onAssignNow}
              style={{ minWidth: 120 }}
            >
              {loader ? <Loading size={14} white /> : null}
              Update
            </Button>
          </div>
        </Paper>
      </MTModal>
    )
}
const initConfig = {
    id:'',
    org_id:'',
    questions:[],
    exam_code:'',
    duration:null,
    levels:{}
}
const ExamConfigToDistrict = ({ openEditModal, setOpenEditModal, district_id, config, organization, loadPlacementOrgList, exam_code , exam_data ,exam_cnf }) => {
    const showAlert = useAlert();
    const [loader, setLoader] = useState(null)
    const [error, setError] = useState(null)
    const [config_data, setConfig_data] = useState(initConfig)
    const dispatch = useDispatch()
    const inputRefs = useRef({})
    const innerRef = useRef(null)
    const levels_config = useMemo(() => {
        try {
            return exam_cnf && exam_cnf.levels ? exam_cnf.levels[exam_code] || [] : [];
        } catch (error) {
            return []
        }
      
    }, [exam_cnf, exam_code])
    const [validationErrors, setValidationErrors] = useState({});
    const registerInputRef = (key, node) => {
        if (node) {
          inputRefs.current[key] = node;
        }
      };
    useEffect(() => {
        if (typeof config == "object" && !isEmpty(config)) {
            setConfig_data(config)
        } else {
            initConfig.org_id = district_id;
            initConfig.duration = exam_data.duration;
            initConfig.exam_code = exam_code;
            initConfig.levels = levels_config;
            setConfig_data(initConfig)
        }
        setLoader(false)
        setError(null)
    }, [district_id, config, openEditModal,levels_config,exam_data])

    const validateForm = () => {
        const newErrors = {};
        config_data?.questions?.forEach((q, i) => {
          const qKey = `question_${i}`;
          if (!q?.question_text?.trim()) {
            newErrors[qKey] = "Question text is required.";
          }
      
          if (q?.type === "multiple_choice") {
            const filledOptions = q?.options?.filter(opt => opt?.trim());
      
            if (filledOptions?.length < 2) {
              newErrors[`${qKey}_min`] = "At least two options are required.";
            }
      
            q?.options?.forEach((opt, j) => {
              if (!opt?.trim()) {
                newErrors[`question_${i}_option_${j}`] = "Option cannot be empty.";
              }
            });
          }
        });
      
        setValidationErrors(newErrors);
      
        if (Object.keys(newErrors).length > 0) {
          const firstKey = Object.keys(newErrors)[0];
        //   inputRefs.current[firstKey]?.focus?.();
          return false;
        }
      
        return true;
      };
    const onAssignNow = async () => {
        if (!district_id) {
            showAlert(`Please select district`,"error");
            return;
        } else if(config_data?.questions?.length == 0){
            showAlert(`Please add at least one question`,"error");
            return;
        } else if(!config_data?.duration){
            showAlert(`Please enter duration`,"error");
            return;
        }
        if(!validateForm()) return;
        setLoader(true)
        try {
            const on_assign = await dispatch(handleConfigureExamPlacementExamByOrg(district_id, config_data))
            if (on_assign && on_assign.success) {
                showAlert(`Updated Successfully`,"success")
                setOpenEditModal(false)
                setConfig_data(init_config)
                loadPlacementOrgList()
            } else if (on_assign && on_assign.status_code == '400') {
                showAlert(on_assign.message,"error")
                setError(on_assign.message)
            } else {
                showAlert(`Something went wrong`,"error")
            }
        } catch (error) {
            showAlert(`Something went wrong`,"error")
        } finally {
            setLoader(false)
        }
    }
    const onDtChange = (key, value) => {
        setConfig_data((prev) => {
            return {
                ...prev,
                [key]: value,
            };
        });
    };
    const [shouldScroll, setShouldScroll] = useState(false);

    useEffect(() => {
        if (shouldScroll && innerRef.current) {
            const scrollHeight = innerRef.current.scrollHeight;
            // Subtract 150px from scrollHeight to show more space above
            innerRef.current.scrollTo({
                top: Math.max(0, scrollHeight - 460),
                behavior: 'smooth'
            });
            setShouldScroll(false);
        }
    }, [shouldScroll, config_data?.questions?.length]);

    const handleAddQuestion = () => {
        setConfig_data((prev) => ({
            ...prev,
            questions: [
                ...prev.questions,
                {
                    type: "multiple_choice",
                    question_text: "",
                    options: ["",""]
                },
            ],
        }));
        setShouldScroll(true);
    };

    const handleRemoveQuestion = (index) => {
        const newQuestions = [...config_data.questions];
        newQuestions.splice(index, 1);
        setConfig_data((prev) => ({
            ...prev,
            questions: newQuestions,
        }));
    };

    const handleQuestionChange = (index, key, value) => {
        const newQuestions = [...config_data.questions];
        newQuestions[index][key] = value;
        setConfig_data((prev) => ({
            ...prev,
            questions: newQuestions,
        }));
    };

    const handleOptionChange = (qIndex, optIndex, value) => {
        const newQuestions = [...config_data.questions];
        newQuestions[qIndex].options[optIndex] = value;
        setConfig_data((prev) => ({
            ...prev,
            questions: newQuestions,
        }));
    };

    const handleAddOption = (qIndex) => {
        const newQuestions = [...config_data.questions];
        newQuestions[qIndex].options.push("");
        setConfig_data((prev) => ({
            ...prev,
            questions: newQuestions,
        }));
    };

    const handleRemoveOption = (qIndex, optIndex) => {
        const newQuestions = [...config_data.questions];
        newQuestions[qIndex].options.splice(optIndex, 1);
        setConfig_data((prev) => ({
            ...prev,
            questions: newQuestions,
        }));
    };
    return (
        <MTModal
            open={openEditModal}
            onClose={() => setOpenEditModal(false)}
            style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
        >
            <Paper
                style={{
                    width: "95%",
                    maxWidth: "800px",
                    maxHeight: "90vh",
                    overflow: "hidden",
                    borderRadius: 8,
                    position: "relative",
                    padding: 0,
                }}
            >
                {/* Sticky Header */}
                <div
                    style={{
                        padding: "16px 24px",
                        borderBottom: "1px solid #ddd",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "#fafafa",
                        position: "sticky",
                        top: 0,
                        zIndex: 100,
                    }}
                >
                    <Typography variant="h6" style={{ fontWeight: 600 }}>
                        Configure {organization?.displayName || "District"}
                    </Typography>
                    <IconButton onClick={() => setOpenEditModal(false)}>
                        <Close color="secondary" />
                    </IconButton>
                </div>

                {/* Scrollable Content */}
                <div
                    style={{
                        padding: 24,
                        overflowY: "auto",
                        maxHeight: "calc(90vh - 64px - 64px)", // adjust for header & footer
                    }}
                >
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                label="Duration"
                                type="number"
                                value={config_data.duration}
                                onChange={(e) => onDtChange("duration", e.target.value)}
                            />
                        </Col>


                        <Col span={24}>
                            <Button
                                onClick={handleAddQuestion}
                                color="primary"
                                startIcon={<PlusOutlined />}
                                style={{ marginBottom: 16 }}
                            >
                                Add Question
                            </Button>
                            <InnerWrapper ref={innerRef} >
                            {config_data?.questions?.map((q, index) => (
                                <Paper key={index} style={{ padding: 16, marginBottom: 16, border: "1px solid #eee" }}>
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <CustomSelector
                                                value={q.type}
                                                onChange={(value) => handleQuestionChange(index, "type", value)}
                                                style={{ width: "100%" }}
                                                getPopupContainer={(trigger) => trigger.parentNode} // Ensures dropdown renders in modal
                                            >
                                                <Select.Option value="multiple_choice">Multiple Choice</Select.Option>
                                                <Select.Option value="open_response">Open Response</Select.Option>
                                            </CustomSelector>
                                        </Col>

                                        <Col span={24}>
                                            <Acent
                                                inputRef={inputRefs.current["question_"+index]}
                                                setValue={(v) => handleQuestionChange(index, "question_text",v)}
                                                style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }}
                                            />
                                            <TextField
                                                fullWidth
                                                label="Question Text"
                                                variant="outlined"
                                                inputRef={(ref) => registerInputRef(`question_${index}`, ref)}
                                                InputLabelProps={{ shrink: true }}
                                                value={q.question_text}
                                                error={!!validationErrors[`question_${index}`]}
                                                onChange={(e) => handleQuestionChange(index, "question_text", e.target.value)}
                                            />
                                        </Col>

                                        {q.type === "multiple_choice" && (
                                            <>
                                                {q.options.map((opt, optIndex) => (
                                                    <Col span={24} key={optIndex}>
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            <div style={{ display:"flex" , flexDirection:"column", width:"97%"}}>
                                                            <Acent
                                                                inputRef={inputRefs.current[`question_${index}_option_${optIndex}`]}
                                                                setValue={(v) => handleOptionChange(index, optIndex, v)}
                                                                style={{ marginBottom: 5, display: "flex", justifyContent: "flex-end" }}
                                                            />
                                                            <TextField
                                                                fullWidth
                                                                variant="outlined"
                                                                label={`Option ${optIndex + 1}`}
                                                                InputLabelProps={{ shrink: true }}
                                                                value={opt}
                                                                error={!!validationErrors[`question_${index}_option_${optIndex}`]}
                                                                inputRef={(ref) => registerInputRef(`question_${index}_option_${optIndex}`, ref)}
                                                                onChange={(e) => handleOptionChange(index, optIndex, e.target.value)}
                                                            />  
                                                            </div>
                                                            <IconButton
                                                                onClick={() => handleRemoveOption(index, optIndex)}
                                                                disabled={q.options.length <= 1}
                                                                style={{ marginLeft: 8 }}
                                                                size="small"
                                                                aria-label="remove option"
                                                            >
                                                                <DeleteOutlined style={{ color: '#f5222d' }} />
                                                            </IconButton>
                                                        </div>
                                                    </Col>
                                                ))}

                                                <Col span={24}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        onClick={() => handleAddOption(index)}
                                                        startIcon={<PlusOutlined />}
                                                       
                                                    >
                                                        Add Option
                                                    </Button>
                                                </Col>
                                            </>
                                        )}
                                        {validationErrors[`question_${index}_min`] && (
                                            <Typography variant="caption" style={{ color: "#f5222d", marginTop: 4 }}>
                                                {validationErrors[`question_${index}_min`]}
                                            </Typography>
                                        )}
                                        <Col span={24} style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <Button
                                                color="secondary"
                                                danger
                                                startIcon={<DeleteOutlined />}
                                                onClick={() => handleRemoveQuestion(index)}
                                            >
                                                Remove Question
                                            </Button>
                                        </Col>
                                    </Row>
                                </Paper>
                            ))}
                            </InnerWrapper>
                        </Col>

                        {error && (
                            <Col span={24}>
                                <Typography variant="subtitle2" style={{ color: "red", whiteSpace: "pre-wrap" }}>
                                    * {error}
                                </Typography>
                            </Col>
                        )}
                    </Row>
                </div>

                {/* Sticky Footer */}
                <div
                    style={{
                        padding: 16,
                        borderTop: "1px solid #eee",
                        background: "#fff",
                        textAlign: "right",
                        position: "sticky",
                        bottom: 0,
                        zIndex: 100,
                    }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={loader}
                        onClick={onAssignNow}
                        style={{ minWidth: 120 }}
                    >
                        {loader ? <Loading size={14} white /> : null}
                        Update
                    </Button>
                </div>
            </Paper>
        </MTModal>
    )
}

const PlacementExamAssignForm = ({
    data,
    userloading
}) => {
    const showAlert = useAlert();
    const navigate = useNavigate();
    const [data_loader, setDataLoader] = useState(false)
    const placemntExamAssignment = usePlacementExamDistrictList()
    const [dist_org_assign, setDistOrgAssign] = useState([])
    const dispatch = useDispatch();
    const [filteredStanders, setFilteredPlacementExams] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [page, setPage] = React.useState(0);
    const [openAssignModal, setAssignModal] = useState(false);
    const [selectedAssignOrg,setSelectedAssignmentsOrg] = useState({})
    const [openDeactivateModal ,setDeactivateModal] = useState(false);
    const [deactibvate_loading ,setDeactibvate_loading] = useState(false);
    const [openDistrictConfig, setDistrictConfig] = useState(false)
    const [openExamOrgConfig, setOpenExamConfig] = useState(false)

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    useEffect(() => {
        if (data && data.id) {
            if (placemntExamAssignment && placemntExamAssignment[data.id]) {
                setDistOrgAssign(placemntExamAssignment[data.id])
                setFilteredPlacementExams(placemntExamAssignment[data.id]);
            } else {
                setDistOrgAssign([])
            }
        } else {
            setDistOrgAssign([])
        }
    }, [placemntExamAssignment, data]);
    async function loadPlacementOrgList() {
        setDataLoader(true)
        try {
            const list = await dispatch(handleListDistrictplacemetExamByExamId(data.id))
        } catch (error) {
            Sentry.captureException(`383 Error during loadPlacementOrgList: ${error}`); 
        } finally {
            setDataLoader(false)
        }

    }
    useEffect(() => {
        if (data && data.id) {
            loadPlacementOrgList()
        }
    }, [data])


    const onSearch = (event) => {
        if (event.target.value && event.target.value.length >= 1) {
            var search = event.target.value;

            const filtered = filter(dist_org_assign, ({ organization }) => {
                return organization ? `${organization.displayName}`.toLowerCase().includes(search.toLowerCase()) : null
            });
            setFilteredPlacementExams(filtered);
        } else {
            setFilteredPlacementExams(dist_org_assign);
        }
    };

    const onDeactivate = async () => {
        setDeactibvate_loading(true)
        try {
            if (selectedAssignOrg && selectedAssignOrg.assigned) {
                let { exam_id, status, id } = selectedAssignOrg.assigned;
                showAlert(status ? 'Deactivating..' : "Activating..","info")
                await dispatch(handleDeactivateAssignToDistrict(id, !status , exam_id))
                showAlert(status ? 'Deactivated successfully' : "Activated successfully.","success")
            }  
        } catch (error) {
            console.log(error.message)
            Sentry.captureException(`384 Error during onDeactivate: ${error}`);     
            showAlert("Something went wrong.","error")
        } finally {
            setDeactibvate_loading(false)
            setDeactivateModal(false)
        }
    }

    useEffect(() => {
        document.documentElement.style.overflow = "hidden";
        // document.body.style.overflow = "hidden";
        disableBodyScroll('PlacementExamAssignForm');

        return () => {
            document.documentElement.style.overflow = "auto";
            document.body.style.overflow = "auto";
        };
    }, []);

    return (
        <SentryWrap>
            <SpinLoader dataloader={data_loader} />
            <AssignToDsitrict openEditModal={openAssignModal} setOpenEditModal={setAssignModal} exam_id={data.id} />
            <ConfigureToDsitrict
                openEditModal={openDistrictConfig}
                setOpenEditModal={setDistrictConfig}
                district_title={''}
                config={selectedAssignOrg?.config}
                organization={selectedAssignOrg?.organization}
                district_id={selectedAssignOrg?.organization?.id}
                loadPlacementOrgList={loadPlacementOrgList}
                exam_code={selectedAssignOrg?.assigned?.assignment_code}
                exam_data={data}
            />
            <ExamConfigToDistrict
                openEditModal={openExamOrgConfig}
                setOpenEditModal={setOpenExamConfig}
                district_title={''}
                config={selectedAssignOrg.exam_config}
                organization={selectedAssignOrg?.organization}
                district_id={selectedAssignOrg?.organization?.id}
                loadPlacementOrgList={loadPlacementOrgList}
                exam_cnf={selectedAssignOrg?.config}
                exam_code={selectedAssignOrg?.assigned?.assignment_code}
                exam_data={data}
            />
            <Wrapper>
                <Row className="editQuizUpr">
                    <Col xs={24} sm={24} md={24} style={{ padding: "10px 12px 12px 12px" }}>
                        <Row justify="start" style={{ alignItems: "flex-end" }} gutter={[15, 15]}>
                            <Col span={5}>
                                <AntdButton
                                    onClick={() => setAssignModal(true)}
                                    style={{ minHeight: 38 }}
                                    type="primary"
                                >
                                    <PlusOutlined /> Assign now
                                </AntdButton>
                            </Col>
                            <Col span={3}>
                            </Col>
                        </Row>

                    </Col>
                </Row>
                <FilterContainer className="FilterHeading">
                    <Card type="inner" title="Filters">
                        <Row>
                            <Col xs={24} lg={24} md={24} className="ColCardPadding">
                                <Card style={{ width: "100%" }}>
                                    <Input
                                        placeholder="Search by name"
                                        bordered={false}
                                        style={{ height: "32px" }}
                                        onChange={onSearch}
                                    />
                                </Card>
                            </Col>
                        </Row>
                    </Card>
                </FilterContainer>
                <StableWrapper>
                    <TableContainer
                        component={Paper}
                        style={{
                            maxHeight: "65vh", // Restrict table container height
                            overflowY: "auto", // Enable scrolling for the body
                        }}
                    >
                    <Table
                        stickyHeader
                        aria-label="sticky table"
                        style={{
                            width: "100%",
                            textAlign: "center",
                            backgroundColor: "#fff",
                            marginTop: 20,
                        }}
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                                >
                                    District
                                </TableCell>
                                <TableCell
                                    style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                                >
                                    Code
                                </TableCell>
                                <TableCell
                                    style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                                >
                                    Assigned on
                                </TableCell>
                                <TableCell
                                    style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                                >
                                 District  Configure
                                </TableCell>
                                <TableCell
                                    style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                                >
                                 Exam  Configure
                                </TableCell>
                                <TableCell
                                    style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                                >
                                    View submission
                                </TableCell>
                                <TableCell
                                    style={{ textAlign: "left", fontSize: 16, fontWeight: "600" }}
                                >
                                    Status
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {isEmpty(filteredStanders) &&
                                (userloading ? (
                                    <Loading size={30} />
                                ) : (
                                    <TableRow key={"0"} style={{ border: 0 }}>
                                        <TableCell colSpan={8} style={{ textAlign: "center" }}>
                                            No results
                                        </TableCell>
                                    </TableRow>
                                ))}
                            {!isEmpty(filteredStanders) &&
                                filteredStanders
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row) => {
                                        return (
                                            <TableRow
                                                key={row.id}
                                                style={{
                                                    "&:lastChild td, &:lastChild th": { border: 0 },
                                                }}

                                            >
                                                <TableCell>
                                                    {" "}
                                                    {row && row.organization && row.organization.displayName ? row.organization.displayName : '-'}
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        textAlign: "left",
                                                        color: BORDERCOLOR[0],
                                                    }}

                                                >
                                                    {row && row.assigned && row.assigned.assignment_code ? row.assigned.assignment_code : '-'}
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        textAlign: "left",
                                                        color: BORDERCOLOR[0],
                                                        maxWidth: 380,
                                                    }}
                                                    onClick={() => { }}
                                                >
                                                    {row && row.assigned && row.assigned.assigned_on ? moment(row.assigned.assigned_on).format('YYYY-MM-DD') : '-'}
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        textAlign: "left",
                                                        color: BORDERCOLOR[0],
                                                        maxWidth: 380,
                                                    }}
                                                    onClick={() => {
                                                        setSelectedAssignmentsOrg(row)
                                                        setDistrictConfig( true)
                                                     }}
                                                >
                                                    <IconButton><SettingFilled style={{ color: row.config ? COLOR.greentrue : COLOR.gray100 }} /></IconButton>
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        textAlign: "left",
                                                        color: BORDERCOLOR[0],
                                                        maxWidth: 380,
                                                    }}
                                                    onClick={() => {
                                                        setSelectedAssignmentsOrg(row)
                                                        setOpenExamConfig(true)
                                                     }}
                                                >
                                                    <IconButton><SettingFilled style={{ color: row.exam_config ? COLOR.greentrue : COLOR.gray100 }} /></IconButton>
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        textAlign: "left",
                                                        maxWidth: 380,
                                                        paddingLeft: 50,
                                                    }}
                                                >
                                                    <IconButton
                                                        style={{ padding: 0, margin: "auto" }}
                                                        onClick={() => {
                                                            const examId = data?.id;
                                                            const code = row?.assigned?.assignment_code;
                                                            const orgId = row?.organization?.id;
                                                            if (!examId || !code || !orgId) {
                                                                showAlert('Missing exam or district data', 'error');
                                                                return;
                                                            }
                                                            const q = new URLSearchParams({
                                                                exam_id: String(examId),
                                                                exam_code: String(code),
                                                                org_id: String(orgId),
                                                            });
                                                            navigate(`/placement_exam_submissions?${q.toString()}`);
                                                        }}
                                                    >
                                                        <Assignment color="primary" style={{ color: color.green100 }} />
                                                    </IconButton>
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        textAlign: "left",
                                                        color: BORDERCOLOR[0],
                                                        maxWidth: 380,
                                                    }}
                                                >
                                                   <Button variant="contained" color={row && row.assigned && row.assigned.status?"primary":"secondary"}  onClick={() =>{
                                                    setDeactivateModal(true)
                                                    setSelectedAssignmentsOrg(row)
                                                   }} >
                                                     {row && row.assigned && row.assigned.status?"Active":"Disabled"}
                                                   </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                {!isEmpty(filteredStanders) && (
                                    <TablePagination
                                        count={filteredStanders.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                        backIconButtonProps={{
                                            color: "secondary",
                                        }}
                                        nextIconButtonProps={{ color: "secondary" }}
                                    />
                                )}
                            </TableRow>
                        </TableFooter>
                    </Table>
                    </TableContainer>
                </StableWrapper>
            </Wrapper>
            <DeleteModal
                deleteToggle={openDeactivateModal}
                setDeleteToggle={setDeactivateModal}
                onDelete={onDeactivate}
                message={!(selectedAssignOrg&&selectedAssignOrg.assigned?.status)?`Are you sure you want to activate this assignment?`:`Are you sure you want to deactivate this assignment?`}
                loading={deactibvate_loading}
                buttonTitle={!(selectedAssignOrg&&selectedAssignOrg.assigned?.status)?"Activate":"Deactivate"}
                colorSchema={!(selectedAssignOrg&&selectedAssignOrg.assigned?.status)?"primary":"secondary"}

            />
        </SentryWrap>
    );
};
const InnerWrapper = styled.div`
        height: 100%;
        padding: 0px;
        width: 100%;
        overflow-y:scroll;
        overflow-x: hidden;
        scroll-behavior: smooth;
        height: max-content;
        padding-bottom: 5px;
        max-height:52vh;
        border-bottom: 1px dotted;
        padding-right: 6px;
        ::-webkit-scrollbar {
            width: 5px;
            height: 3px;
          }
}
`;



export default PlacementExamAssignForm;
